export var I18NEXT_REDUCER_NAME = 'I18NEXT_REDUCER_NAME';
